import { AutogenLayoutOfficeSuiReport } from './autogen/AutogenLayoutOfficeSuiReport';
import { DataSourceExecutionEvent, ChangeEvent } from "@mcleod/components";

export class OfficeSuiReport extends AutogenLayoutOfficeSuiReport {

    checkboxIncludeSettlementOnChange() {
        this.excludabletextboxPayee.textbox.clear();
        if(this.checkboxIncludeSettlement.checked) {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayee.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayee.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }

    sourceOfficeSuiTaxableWagesBeforeExecution(event: DataSourceExecutionEvent) {
        if(this.checkboxIncludeSettlement.checked) {
            event.filter.includeSettlemts = 'Y';
        }
        else{
            event.filter.includeSettlemts = 'N';
        }
    }
}
